class KlaviyoFallbackForm extends HTMLElement {
  connectedCallback() {
    this.controller?.abort()
    const { signal } = (this.controller = new AbortController())

    const embed = this.querySelector('.klaviyo-fallback-form__embed')
    const fallback = this.querySelector('[data-fallback]')
    const form = this.querySelector('[data-form]')
    const message = this.querySelector('[data-message]')
    if (!embed || !fallback) return

    const delay = Number(this.dataset.revealDelay) || 2500

    const klaviyoLoaded = () => {
      // Shopify's editor sometimes injects a stray <br> into empty
      // elements, which counts as a child node but isn't real content.
      const hasElementChild = Array.prototype.some.call(
        embed.childNodes,
        (node) => node.nodeType === 1 && node.tagName !== 'BR'
      )
      return hasElementChild || embed.textContent.trim().length > 0
    }

    this.revealTimer = window.setTimeout(() => {
      if (!klaviyoLoaded()) fallback.hidden = false
    }, delay)

    if (!form || typeof window.fetch !== 'function') return // no fetch -> native form submit still works

    form.addEventListener(
      'submit',
      (event) => {
        event.preventDefault()
        const formData = new FormData(form)
        const payload = {}
        formData.forEach((value, key) => {
          payload[key] = value
        })

        fetch(form.action, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload),
        })
          .then((res) => res.json().then((data) => ({ ok: res.ok && data.ok, error: data.error })))
          .then((result) => {
            if (result.ok) {
              form.hidden = true
              if (message) message.textContent = form.dataset.successMessage || "You're in!"
            } else if (message) {
              message.textContent = result.error || 'Something went wrong, please try again.'
            }
          })
          .catch(() => {
            if (message) message.textContent = 'Something went wrong, please try again.'
          })
      },
      { signal, passive: false }
    )
  }

  disconnectedCallback() {
    this.controller?.abort()
    window.clearTimeout(this.revealTimer)
  }
}

customElements.define('klaviyo-fallback-form', KlaviyoFallbackForm)
